import { make } from 'vuex-pathify';

const state = {
    title: 'Developing Your Own Action Plan',
    complete: false,
    sticker: {
        text: 'Map',
        earned: false,
        image: require('@/assets/stickers/stickers_0010_map.png')
    },
    bonusSticker: false,
    trophy: {
        text: 'Shield',
        earned: false,
        image: require('@/assets/trophies/trophy_0000_shield.png')
    }
};
const getters = make.getters(state);
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
